export class MisInventory {
    userID : string;

    fromDate: string;
    toDate: string;
    PageNo: number;
    PageNo1: number;

}
